<template>
  <div class="page" v-wechat-title="$route.meta.title">
    <!--轮播图-->
    <div class="swiper-con border-box" style="position: relative;">
      <Swiper :banners="banners" :type="'home'"></Swiper>
    </div>

    <!--语音讲解-->
    <div class="voice-box" >

      <div class="list-box box border-box" v-for="(item,index) in bagList" :key="index" v-if="(vmodel!=3&&vmodel!=4)">
        <div class="block list-img">
          <img alt="" class="icon-tx" :src="item.headimg">
          <div class="listen-btn-num"  @click.stop="listenTurlClick(index,'bagList')" v-if="item.buy!=12&&item.price>0">
            <img :src="item.isplay==1?require('../../assets/icon_listen02.gif'):require('../../assets/icon-listen.png')" alt="">
            <span>{{item.isplay==1?item.resTime+"'":"试听"}}</span>
          </div>
        </div>
        <div class="block flex list-info">
          <div class="list-name guide-name hide">{{item.name}}</div>
          <div class="clearfix">
            <div class="label-color" v-if="item.listen>0">
              <img src="../../assets/adot-5.png" alt="">
              <span>{{item.listen|initNumber}}人收听</span>
            </div>
            <div class="label-color" v-if="item.buynum>0&&item.price>0">
              <img src="../../assets/adot-3.png" alt="">
              <span>{{item.buynum|initNumber1}}人购买</span>
            </div>
          </div>
          <div class="price-text-box clearfix">
            <div class="price-text" v-if="item.price!=0">
              <div class="sellprice" v-if="item.ptype==1">￥<font>{{item.sellprice}}</font>
                <span class="sees-num-inline" style="text-decoration: line-through;" v-if="item.sellprice>0 && item.sellprice<item.price">/ ￥{{item.price}}</span>
                <span class="sees-num-inline">(包含{{voiceLen}}个讲解)</span>
              </div>
              <div v-else>￥<font>{{item.sellprice}}</font>
                <span class="sees-num-inline" style="text-decoration: line-through;" v-if="item.sellprice>0 && item.sellprice<item.price">/ ￥{{item.price}}</span>
                <span class="sees-num-inline">(包含以下{{shopid==1689?'14':siteBrotherList.length}}个{{res&&res.bag_title?res.bag_title:'场馆'}})</span>
              </div>
            </div>
            <div class="price-text" v-else>
              <div><font>免费</font><span class="sees-num-inline">(包含以下{{shopid==1689?'14':siteBrotherList.length}}个{{item.ptype==1?'讲解':(res&&res.bag_title?res.bag_title:'场馆')}})</span></div>
            </div>
          </div>
          <button class="btn buy-btn buy-btn2 buy-btn3" @click.stop="buyVideo(index,'bagList')" v-if="item.buy!=12&&item.price>0">购买</button>
          <button class="btn buy-btn buy-btn2 buy-btn3 disabled" v-if="item.buy==12&&item.price>0">已购</button>
        </div>
      </div>

      <div v-if="vmodel==1">
        <!--全景视频模块-->
        <div class="video-vr border-box" v-if="VRlist.length>0">
          <div class="video-vr-tit">VR真人讲解
            <router-link class="fr" v-if="VRtotal>3" :to="{path:'/video-vrlist',query: {shopid:shopid,citySite:3,TimeStamp:TimeStamp,appKey:appKeyA}}">查看更多</router-link>
          </div>
          <div class="video-vr-con">
            <div class="video-vr-top" @click="goVideoVR(VRlist[0].id)">
              <div class="video-vr-img" id="video-vr-img" v-if="VRlist[0].vrimg&&VRlist[0].vrimg!=''&&VRlist[0].vrimg!=null"></div>
              <img class="video-vr-img" v-lazy="VRlist[0].tvideourl" alt="" v-else>
              <span class="video-vr-mask" v-if="loadPSV"></span>
              <img class="video-vr-btn pause" src="../../assets/view-video-bf.png" alt="" v-if="loadPSV">
              <img class="icon_360" src="../../assets/icon_360.png" alt="">
              <div class="video-tit border-box hide">{{VRlist[0].name}}</div>
              <span class="video-vr-txt num">{{VRlist[0].listen|initNumber}}次播放</span>
              <span class="video-vr-txt spot">{{VRlist[0].spotNum}}个讲解点</span>
            </div>

            <div class="video-vr-top" @click="goVideoVR(VRlist[1].id)" style="margin-top: .24rem"  v-if="VRtotal==2">
              <img class="video-vr-img" v-lazy="VRlist[1].vrimg" alt="">
              <span class="video-vr-mask"></span>
              <img class="icon_360" src="../../assets/icon_360.png" alt="">
              <div class="video-tit border-box hide">{{VRlist[1].name}}</div>
              <span class="video-vr-txt num">{{VRlist[1].listen|initNumber}}次播放</span>
              <span class="video-vr-txt spot">{{VRlist[1].spotNum}}个讲解点</span>
            </div>
          </div>


          <div class="video-vr-con video-vr-con1" v-if="VRtotal>2">
            <div class="video-vr-top" :class="index==1?'fl':'fr'" v-for="(item,index) in VRlist" :key="index" @click="goVideoVR(item.id)" v-if="index>0">
              <img class="video-vr-img" v-lazy="item.vrimg" alt="">
              <span class="video-vr-mask" v-if="loadPSV"></span>
              <img class="icon_360" src="../../assets/icon_360.png" alt="">
              <div class="video-tit border-box hide">{{item.name}}</div>
              <span class="video-vr-txt num">{{item.listen|initNumber}}次播放</span>
              <span class="video-vr-txt spot">{{item.spotNum}}个讲解点</span>
            </div>
          </div>
        </div>

        <div class="video-vr-tit border-box" style="padding: 0 .26rem;height: .76rem">包含景区</div>
        <ul class="zg-ul clearfix">
          <li v-for="(item,index) in siteBrotherList" :key="index" @click="goViewDetail(item.id)">
            <img v-lazy="item.logo" alt="">
            <p class="hide">{{item.name}}</p>
          </li>
        </ul>
        <p class="load-tip" v-if="siteBrotherList<=0">暂无数据</p>
      </div>

      <div v-if="vmodel==2||vmodel==3||vmodel==4">
        <div class="video-vr border-box" v-for="(item,index) in vrbagList" :key="index" v-if="vrbagList.length>0">
          <div class="video-vr-tit border-box" @click="goViewDetail(item.id)">{{item.simplename}} <img src="../../assets/back.png" alt=""></div>
          <div class="video-vr-con clearfix" :class="(item.vr.length%2==1&&item.vr.length!=1)?'video-vr-con1':''" v-if="item.vr&&item.vr.length>0">
            <div class="video-vr-top" :class="[ind==0?'index0':'',ind%2==1?'fl':'fr']" @click="goVideoVR(ite.id)" v-for="(ite,ind) in item.vr" :key="ind">

              <div class="video-vr-img" :id="index==0&&ind==0?'video-vr-img0':''" v-if="ite.vrimg&&ite.vrimg!=''&&ite.vrimg!=null&&ind==0&&index==0"></div>
              <img class="video-vr-img" v-lazy="ite.tvideourl" alt="" :key="ite.id" v-else>

              <span class="video-vr-mask" v-if="loadPSV"></span>
              <img class="video-vr-btn pause" src="../../assets/view-video-bf.png" alt="" v-if="item.vr.length%2==0||item.vr.length==1||ind==0">
              <img class="icon_360" src="../../assets/icon_360.png" alt="">
              <div class="video-tit border-box hide">{{ite.name}}</div>
              <span class="video-vr-txt num">{{ite.listen|initNumber}}次播放</span>
              <span class="video-vr-txt spot">{{ite.spotNum}}个讲解点</span>
            </div>
          </div>

          <div class="list-box" :class="[ind==0?'index0':'',item.vr.length<=0?'vrnone':'']" v-for="(ite,ind) in item.voice" :key="ind" @click="goVideoPlay(ite.id,ite.shopid)">
            <div class="list-box1 box">
              <div class="block list-img">
                <img class="icon-tx" v-lazy="ite.headimg" alt="">
              </div>
              <!--右侧语音内容部分-->
              <div class="block flex list-info border-box" style="padding-top: .24rem;">
                <div class="list-name guide-name hide">{{ite.fname}}
                  <span v-if="ite.guidetag">{{ite.guidetag}}</span>
                </div>
                <div class="list-group hide" style="margin-top: .12rem;">
                  <span class="fl hide" style="max-width: 100%;">{{ite.name}}</span>
                  <span class="fl hide" v-if="ite.label">{{ite.name}}</span></div>
                <!--标签-->
                <div class="clearfix" style="margin-top: .18rem;">
                  <div v-if="ite.listen>0" class="label-color" style="margin-top: 0;">
                    <img class="fl" src="../../assets/adot-5.png" alt="" style="width: auto;height: .32rem;margin-right: .1rem;">
                    <span style="height: .32rem;line-height: .32rem;">{{ite.listen|initNumber}}人收听</span>
                  </div>
                </div>
                <!--价格-->
                <div class="price-text-box clearfix">
                  <div class="label-color">
                    <img class="fl" style="top:0;margin-right: .1rem;margin-top: .15rem;-webkit-transform: translateY(0);transform: translateY(0);" src="../../assets/adot-7.png" alt=""> 包含{{ite.spotNum}}个讲解点
                  </div>
                </div>
                <!--右侧购买收听按钮-->
                <button class="btn buy-btn" @click.stop="goVideoPlay(ite.id,ite.shopid)" v-if="vmodel==2||vmodel==3||(vmodel==4&&ite.isbuy!==0)">收听</button>
                <button class="btn buy-btn" @click.stop="buyVideo1(ite.id,ite.shopid)" v-if="vmodel==4&&ite.isbuy===0">购买</button>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div v-else>
        <div class="video-vr-tit border-box" style="padding: 0 .26rem;height: .76rem">包含景区</div>
        <ul class="zg-ul clearfix">
          <li v-for="(item,index) in siteBrotherList" :key="index" @click="goViewDetail(item.id)">
            <img v-lazy="item.logo" alt="">
            <p class="hide">{{item.name}}</p>
          </li>
        </ul>
        <p class="load-tip" v-if="siteBrotherList<=0">暂无数据</p>
      </div>

    </div>



    <!--试听结束弹窗新版-->
    <AlertListenEnd  :bag="bag" :couponid="couponid" :extral="extral" :shopid="shopid" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <!--提醒用户购买弹窗弹窗-->
    <AlertPayTip @close="closePayTip" :comeForm="0" v-if="buyTip==1"></AlertPayTip>

    <!--自定义富文本弹窗-->
    <AlertRichTxtTip @close="closeRichTxtTip" :comeForm="0" :shopname="shop.name" :richTxt="richTxt"  v-if="richTxt"></AlertRichTxtTip>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>



    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>

<script>

  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import { mapState, mapMutations } from 'vuex'
  import Swiper from '../../components/Swiper'
  import {getViewDetail, getBagTab, getCatalogue, uploadScan,uploadUserBrowse,siteMore,siteVrlist,siteVrlist2,siteVrlist3,userinfoLogin} from "@/service/getData";
  import {wxGetPosition,wxShareme,listenEndOrder, listenTurl, creatOrder, pushOrder} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertListenEnd from '../../components/AlertListenEnd'
  import AlertPayTip from '../../components/AlertPayTip'
  import AlertRichTxtTip from '../../components/AlertRichTxtTip'
  import P400 from '../../components/P400'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        code: this.$route.query.code || '', //城市站点id
        siteid:'',//站点id
        sregion:'',//省站点id:430000
        qrcode: '', //是否是扫码
        qid: '', //扫码id
        shopid: '', //景区id
        spotid: '', //景点id
        userInfo: {}, //用户信息
        inputValue: '',//搜索关键词
        page: 1,
        rows: 10,
        loadText: "数据加载中",
        res: "", //全部数据
        cid: "", //导游筛选
        tlist: [], //试听列表
        bagList: [],//解说列表
        total: '',//解说总数
        banners: [], //banner图片或者video
        shop: '',//景区信息
        routes: '',//游玩路线
        tablist: [],//导游分类列表
        tabIntroCurr: 1,//语音、景区详情及目录切换
        catalogueCurr: 0,//目录弹窗
        catalogueRoot: [],//目录弹窗内容
        buyTip: 0, //购买提醒弹窗
        richTxtTip: 1, //自定义富文本弹窗
        richTxt: '',//自定义弹窗内容

        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id
        listType: '', //所点击的语音列表类型‘tjList:推荐列表’，‘bagList:其他列表’
        lastListType: '', //记录上一次所点击的语音列表类型‘tjList:推荐列表’，‘bagList:其他列表’

        siteBrotherList: [], //场馆列表

        vmodel: '', //页面样式 1： 2：
        vrbagList: [], //vmodel为2时的数据
        vrData: '', //第一个VR数据
        VRlist: [], //VR视频列表
        VRtotal: 0, //VR视频专辑总数
        PSV: null, //全景图片
        loadPSV: false, //全景是否加载完


        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        P400: 0, //系统维护中

        usernote: this.$route.query.usernote || '', //扫码得到的时间戳
        order: this.$route.query.order || '', //扫码得到排序
        voiceLen: 0,//ptype=1时 的讲解数量
      }
    },
    computed: {

    },
    created(){
      this.$loading.show('数据加载中');
      this.shopid = this.$route.query.shopid;
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }
      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }
      this.initData();

      this.qrcode = this.$route.query.qrcode;
      this.qid = this.$route.query.qid;
      if(this.qid){
        setStore("qid", {"qid":this.qid});
      }
      if(this.qrcode){
        let self = this;
        wxGetPosition(function(res){
          self.sendScan(res.latitude,res.longitude);
        });
      }

      if(this.usernote && this.TimeStamp - this.usernote < 1500 ){ //时间小于1.5s
        this.$alert('如您使用时退出了页面，可在景区内重新扫码进入');
      }

    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun);
      if(this.videoTimer){
        clearInterval(this.videoTimer);
        this.currIndex = -1;
        this.bagList[this.index1].isplay = 0;
        this.tlist[this.index1].isplay = 0;
        this.bag = {};
      }
      if (this.PSV) {
        this.PSV.destroy()
      }
    },
    methods: {

      //获取语音+景区+推荐信息
      async initData(){
        let res = await siteMore({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          id: this.shopid
        });

        if (res.errcode === "00000"){
          this.$loading.hide();

          this.banners = res.data.banner;

          this.siteBrotherList = res.data.list;


          for(var i=0; i<res.data.voice.length; i++){
            res.data.voice[i].isplay = 0;
            res.data.voice[i].toaTime = '';
            res.data.voice[i].resTime = '';
          }
          this.bagList = res.data.voice;

          var shopname = res.data.voice[0].name;
          console.log(shopname);
          var share = res.data.share;
          let link = '/view-detail-group?shopid='+ this.shopid +'&siteid='+ this.siteid + '&sregion='+ this.sregion  +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          if(share == null){
            let title = '金牌解说 | ' + shopname;
            let desc = '历史会说话！金牌解说为您讲解' + shopname + '的历史故事';
            let img = this.banners[0].imgurl;
            wxShareme(title,desc,img,link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }

          this.$route.meta.title = shopname;

          this.res = res.data;
          this.vmodel = res.data.vmodel;
          if(res.data.vmodel == 1){
            this.getVr();
          }else if(res.data.vmodel == 2 || res.data.vmodel == 3){
            this.getVr2();
          }else if(res.data.vmodel == 4){
            this.getVr2(1);
          }

        }else if(res.errcode == "40002"){
          this.userinfoLoginFun()
        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请返回重试';
        }

      },

      //重新上传用户信息
      async userinfoLoginFun(){
        var user = getStore("userInfo");
        let res = await userinfoLogin({
          openid: user.openid,
          avatarUrl: user.headimg || user.headimgurl || 'https://filewc.geeker.com.cn/jpjs/upload/default/girl.jpg',
          nickname: user.nickname || user.name || '匿名用户',
          city: user.city || '',
          gender: user.sex,
          encryptedData: '',
          iv: ''
        });
        if(res.errcode === "00000"){
          location.reload();
          this.$router.go(0);
        }else {
          this.$alert({
            title: '提示',
            content: res.errmsg
          });
        }
      },

      //获取VR数据
      async getVr(){
        let res = await siteVrlist({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          id: this.shopid,
          page:1,
          rows:3
        });
        if(res.errcode == '00000'){
          if(res.data.root != null && res.data.root.length > 0){
            this.VRlist = res.data.root;
            this.VRtotal = res.data.total;
          }
        }
      },

      //获取vr+专辑数据
      async getVr2(type){
        var res;
        if(type==1){
          res = await siteVrlist3({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            id: this.shopid,
            order: this.order
          });
        }else{
          res = await siteVrlist2({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            id: this.shopid,
            order: this.order
          });
        }

        if(res.errcode == '00000'){
          if(res.data!= null && res.data.length > 0){
            this.vrbagList = res.data;
            for(var i=0; i<res.data.length; i++){
              var data = res.data[i];
              if(data.vr.length>0){
                this.vrData = data.vr[0];
                return;
              }
              this.voiceLen = this.voiceLen + data.voice.length;

            }
          }
        }
      },


      //上传扫码数据
      async sendScan(lat,lng){
        let res = await uploadScan({
          openid: this.userInfo.openid,
          shopid: this.shopid,
          qid: this.qid || "",
          lat: lat || "",
          lng: lng || ""
        });
      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },


      //点击试听，调用试听公用方法
      listenTurlClick(ind,listType){
        MtaH5.clickStat('view_detail_listen');
        MtaH5.clickStat('xiangqingyeshit',{'viewdetaillisten':'true'});//景区、景点》1试听弹窗》购买》支付
        MtaH5.clickStat('jingqujingdiana-1',{'1listen':'true'});//景区景点1试听》直接购买》支付
        this.lastListType = this.listType;
        this.listType = listType;

        if(listType == 'tjList'){
          listenTurl(this,ind,this.tlist)
        }else {
          listenTurl(this,ind,this.bagList)
        }

      },


      //点击购买，调用下订单公用方法
      buyVideo(ind,listType){
        MtaH5.clickStat("view_detail_buy");
        MtaH5.clickStat('zhuanjixiangqin',{'choose':'true'});//专辑详情页点击推荐景区》1购买》支付
        MtaH5.clickStat('viewspotbuy',{'1viewspotbuy':'true'});//景区景点直接点击1购买》支付
        MtaH5.clickStat('jingqujingdiana-1',{'2buy':'true'});//景区景点试听》1直接购买》支付
        this.listType = listType;
        let list = listType == 'tjList' ? this.tlist[ind] : this.bagList[ind] ;
        let self = this;

        setStore("source", {"source": "index"})
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+list.id+'&cid='+self.couponid+'&shopid='+self.shopid+'&bagtype=5'+'&appKey='+(self.appKey)}`
        });
      },

      //点击购买，调用下订单公用方法
      buyVideo1(id,shopid){
        let self = this;
        setStore("source", {"source": "group"})
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+id+'&cid=&shopid='+shopid+'&bagtype=5'+'&appKey='+(self.appKey)}`
        });
      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if(msg.isbuy){
          if(this.listType == 'tjList'){
            this.tlist[this.index1].buy = 12;
          }else {
            this.bagList[this.index1].buy = 12;
          }
        }
      },

      //关闭购买提醒弹窗
      closePayTip(msg){
        this.buyTip = msg;
      },
      //
      closeRichTxtTip(msg){
        this.richTxt = msg;
      },

      //跳转到专辑详情页
      goVideoPlay(id,shopid){
        this.$router.push({
          path: `/video-play?${'id='+id+'&spotid=&shopid='+shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
        });
      },

      //跳转到景区页面
      goViewDetail(id){
        this.$router.push({
          path: `/view-detail?${'shopid=' + id + '&siteid=' + this.siteid + '&sregion=' + this.sregion + '&TimeStamp=' + this.TimeStamp + '&appKey=' + this.appKey}`
        });
      },

      //景区介绍
      tabIntroCurr2(){
        this.tabIntroCurr = 2;
        MtaH5.clickStat('view_detail');
      },

      //景点目录
      catalogueCurr1(){
        this.catalogueCurr = 1;
        MtaH5.clickStat("catalogue");
      },

      //跳转到VR视频
      goVideoVR(id){
        this.$router.push({
          path: `/video-vr?${'id='+id+'&shopid='+this.shopid+'&spotid='+this.spotid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2'}`
        });
      },

      showPhotoVR(imgurl,obj){
//        var imgurl = require('../../assets/qj.jpg');
        var self = this;
        this.PSV = PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
          time_anim: 2000, //默认2000
          anim_speed: '2rpm', //默认2rpm
          navbar: false,  //不显示下面的导航栏
          overload: function(){
            self.loadPSV = true;
          }
        });
      },

    },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){
          let list = this.listType == 'tjList' ? this.tlist : this.bagList ;
          listenEndOrder(this,this.index1,list);
        }
      },
      VRlist(){
        var self = this;
        this.$nextTick(function(){
          if(self.VRlist[0].vrimg && self.VRlist[0].vrimg != '' && self.VRlist[0].vrimg != null){
            self.showPhotoVR(self.VRlist[0].vrimg,'video-vr-img');
          }
        })
      },
      vrData(){
        var self = this;
        this.$nextTick(function(){
          console.log(self.vrData);
          if(self.vrData.vrimg && self.vrData.vrimg != '' && self.vrData.vrimg != null){
            self.showPhotoVR(self.vrData.vrimg,'video-vr-img0');
          }
        })
      },
    },
    components: {
      Swiper,
      AlertListenEnd,
      AlertPayTip,
      AlertRichTxtTip,
      P400
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      initNumber1: function (num) { //重置购买数据
        if(num>=1000){
          num = '1000+'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  @import "../../style/voice.css";
  .page{ padding-bottom:.4rem; }
  /*轮播图*/
  .swiper-con{width:100%;height: 3.75rem;}
  .swiper-box,.swiper-box .swiper-container{border-radius: 0!important;}

  .list-box{width:100%;height:2.26rem;padding:.3rem;border-bottom:1px solid #e6e6e6; }
  .list-img{width:2.14rem;height: 1.66rem;}
  .label-color{font-size: .22rem;}
  .list-name{color: #0d0d0d;}
  .list-info .price-text>div{font-size: .24rem;color: #faaf39;}
  .list-info .price-text font{font-size: .36rem;margin-right: .04rem;}
  .list-info .price-text>div.sellprice font{font-size: .28rem;margin-right: 0;}
  .sees-num-inline{display: inline-block;font-size: .2rem;color: #999;}

  /*语音、详情、目录切换*/
  .tab-intro {position: relative;height:1.04rem;text-align:center;color:#3c403b;background:#fff;border-radius:.3rem .3rem 0 0;margin-top:-.3rem;z-index: 1;}
  .tab-intro img {display: block;width:.48rem;height:.48rem;margin:.16rem auto 0;}
  .tab-intro img.scenic-icon-curr{display: none;}
  .tab-intro span {margin-top:.06rem;font-size:.2rem;font-weight:bold;color: #3c403b;}
  .tab-intro .flex.curr .scenic-icon-curr {display: block;}
  .tab-intro .flex.curr .scenic-icon {display: none;}
  .tab-intro .flex.curr span {color: #fcba5a;}


  /*新版景区景点详情*/
  .scenic-padding{padding:.26rem .24rem;background:#fff;font-weight:bold;color:#555;}
  .scenic-details-box{position:relative;background: #fff;}
  .scenic-details-box.curr .scenic-details{height:auto;}
  .scenic-details-title{position:relative;font-size:.3rem;}
  .scenic-details-info{line-height:.4rem;font-size:.26rem;font-weight: normal;}


  .voice-box{position: relative; z-index: 1; border-radius: .15rem .15rem 0 0; margin-top: -.15rem; overflow: hidden; background-color: #fff; }
  .jc-tit{width: 100%;height: .92rem;padding: 0 .3rem;border-bottom: .02rem solid #e3e3e3;font: bold .34rem/.92rem "Microsoft YaHei";color: #333;}
  .buy-btn3{width: 1.46rem;height: .6rem;line-height: .6rem;padding: 0;text-align: center;font-size: .32rem;}
  .listen-btn-num{ top: 50%;width: 1.42rem;height: .5rem;margin-top: -.25rem;line-height: .5rem;}
  .listen-btn-num img{margin-top: .11rem;}
  .listen-btn-num span{height: .5rem;line-height: .5rem;font-size: .20rem;}
  .label-color{margin-top: .22rem;}
  .zg-ul{padding: 0 .3rem;}
  .zg-ul li{float:left;width: 31%;height:2.46rem;padding-top: .2rem;margin-right: 3.5%;}
  .zg-ul li:nth-of-type(3n){margin-right: 0;}
  .zg-ul li img{width: 100%;height:1.68rem;object-fit:cover;border-radius: .08rem;overflow: hidden;}
  .zg-ul li p{width: 100%;padding-top: .16rem;font:.28rem/1.2 "Microsoft YaHei";color: #3d3d3d;text-align: center;}

  /*全景视频*/
  .video-vr{padding: 0 .26rem .25rem;}
  .video-vr-con{width: 100%; border-radius: .1rem;overflow: hidden;}
  .video-vr-tit{width:100%;height: .96rem;font: bold .3rem/1.03rem "Microsoft YaHei";color: #3d3d3d;overflow: hidden;}
  .video-vr-tit .fr{font:normal .24rem/1.03rem "Microsoft YaHei";color: #555;}
  .video-vr-top{ display: block; position:relative;width: 100%;height: 3rem;border-radius: .1rem .1rem 0 0;overflow: hidden;}
  .video-vr-img{position:absolute;top:0;left:0;width: 100%;height: 100%;border-radius: .1rem .1rem 0 0;object-fit: cover;}
  .video-vr-mask{position: absolute;z-index: 1;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.3);}
  .video-vr .icon_360{position: absolute;z-index: 1;top:.12rem;right:.12rem;width: 1.36rem;height: auto;}
  .video-vr .video-tit{position: relative;z-index: 1;width:100%;height:.75rem;padding: 0 1.6rem 0 .2rem;font: .26rem/.75rem "Microsoft YaHei";color: #fff;}
  .video-vr-btn{position: absolute;z-index:1;top:50%;left:50%;width: 1.02rem;height: auto;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .video-vr-txt{position: absolute;z-index: 1;bottom: .14rem;font: bold .2rem "Microsoft YaHei";color: #fff;}
  .video-vr-txt.num{ left:.2rem;}
  .video-vr-txt.spot{ right:.2rem;}

  .video-vr-con1 .video-vr-top{ margin-top: .24rem; width: 48.2%; }
  .video-vr-con1 .icon_360{ top: 42%; right: 50%; margin-right: -.68rem; }

  /*vmodel=2*/
  .video-vr-tit img{ width: auto; height: .24rem; margin-left: .16rem; vertical-align: unset;transform: translateY(1.5px); }
  .video-vr-con .video-vr-top{ margin-top: .24rem;  }
  .video-vr-con .index0{ float: none;margin-top: 0; width: 100%; }
  .video-vr-con .index0 .icon_360{ top:.12rem;right:.12rem; margin-right:0; }
  .video-vr .list-box{ padding: .24rem 0 0; height: 2.4rem; border-bottom: none; }
  .video-vr .list-box.index0{ margin-top: .1rem; }
  .video-vr .list-box.index0.vrnone{ margin-top: 0; padding-top: 0 }
  .video-vr .list-box1{ position: relative; height: 2.4rem; background-color: #f3f3f3; border-radius: .1rem; overflow: hidden; }
  .video-vr .list-box .list-img{ width: 1.84rem; height: 2.4rem; background-color: #f3f3f3;  }
  .video-vr .list-box .list-img img{ object-fit: cover; }
  .video-vr .list-box1 .btn.buy-btn{bottom:.2rem;right: .24rem;}
  .video-vr .list-box1 .price-text-box .label-color{bottom:.2rem;height: .55rem;vertical-align: middle;margin-top: 0;line-height: .55rem !important;}

  .disabled{ background: #e2e2e2; }
</style>



// WEBPACK FOOTER //
// src/page/view-detail/view-detail-group.vue